var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("transition", { attrs: { name: "slide" } }, [
        _vm.siloData.user.id !== 0
          ? _c(
              "nav",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.appState === "home",
                    expression: "appState === 'home'",
                  },
                ],
                staticClass: "tools",
                attrs: { id: "tools" },
              },
              [
                _c(
                  "ul",
                  {
                    staticClass:
                      "tools__list c c--content--pad r r--row-always r--justify-space-between r--halign-center pad--h",
                  },
                  [
                    _c("li", [
                      _c(
                        "button",
                        {
                          staticClass:
                            "tools__list__button r r--row-always r--halign-center",
                          attrs: { onclick: "vapetracker.open()" },
                        },
                        [
                          _c("Icon", { attrs: { name: "icon-tools-track-2" } }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Track")]),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "button",
                        {
                          staticClass:
                            "tools__list__button r r--row-always r--halign-center",
                          on: {
                            click: function ($event) {
                              return _vm.$emit("updateState", "plan")
                            },
                          },
                        },
                        [
                          _c("Icon", { attrs: { name: "icon-tools-plan-2" } }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Plan")]),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "button",
                        {
                          staticClass:
                            "tools__list__button r r--row-always r--halign-center",
                          on: {
                            click: function ($event) {
                              return _vm.$emit("updateState", "tasks")
                            },
                          },
                        },
                        [
                          _c("Icon", { attrs: { name: "icon-tools-tasks-2" } }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Tasks")]),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "button",
                        {
                          staticClass:
                            "tools__list__button r r--row-always r--halign-center",
                          on: {
                            click: function ($event) {
                              return _vm.$emit("updateState", "bonus-topics")
                            },
                          },
                        },
                        [
                          _c("Icon", {
                            attrs: { name: "icon-tools-bonus-topics-2" },
                          }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v("Bonus"),
                            _c("br"),
                            _vm._v("Topics"),
                          ]),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }